<template>
    <v-container bg="l" class="logos">
        <ul class="logos-list">
            <li class="logo" v-for="logo of logos" :key="logo">
                <picture>
                    <source :srcset="require(`@/assets/img/logos/${logo}.webp`)" type="image/webp">
                    <img alt="Логотип клиента" :src="require(`@/assets/img/logos/${logo}.jpg`)" />
                </picture>
            </li>
        </ul>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import VContainer from "@/components/ui/VContainer";

export default {
    name: "Section-Logos",
    components: {
        VContainer
    },
    computed: {
        ...mapState("logos", ["logos"])
    }
};
</script>


<style scoped lang="scss">
.logos-container {
    text-align: center;
    max-width: 1200px;
    margin: 0 auto;
}

.logos-list { 
    // width: 100%; 
    max-width: 990px;
    margin: 0 auto;
    // display: inline-block;
    text-align: center;
}

.logo {
    // width: 16%;
    display: inline-block;
    position: relative;
    margin: 15px;

    & > picture > img,
    & > picture > source {
        max-width: 150px;
        // transform: scale(0.7);
        width: 100%;
    }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
}

@media (max-width: 414px) {
    .logo{
        margin: 10px;
        &>img{
            max-width: 104px;
        }
    }
}

@media (max-width: 375px) {
    .logo{
        margin: 10px;
        &>img{
            max-width: 91px;
        }
    }
}
</style>